import React, { useMemo } from "react";
import Table from "react-bootstrap/Table";
import { Measurement, ReactSelectOption } from "../../../../../store/onboarding/types";
import ColorCriteriaRow from "./ColorCriteriaRow";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPlusCircle, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import { SkillFocusArea } from "../../../../../store/groups/types";

type Props = {
  measurements: Array<Measurement>;
  columnsNames: Array<string>;
  selectedColumnNames: Array<string>;
  handleMeasurementsChange: (
    index: number,
    select?: boolean,
    unique_id?: number
  ) => (event: React.SyntheticEvent) => void;
  handlePossibleValuesChange: (measurement: Measurement) => (index: number) =>any;
  handleMeasurementAdd: () => any;
  handleMeasureEdit: (measurement: Measurement) => any;
  handleMeasurementRemove: (measurement: Measurement) => any;
  basicColumnsHeadersNum: Readonly<number>;
  useGradeSpecificColor?: boolean;
  withReadingAlgorithm?: boolean;
  skill_areas?: ReactSelectOption<string>[];
  handleSkillAreaChange: (
    index: number,
    skill: string
  ) => any;
  newMeasurement?: Measurement;
  isRequiedBasicInfoFilled?: boolean;
  enterDataManuallyType?: "academic" | "behavior";
};

const MeasurementsTable = (props: Props) => {
  const {
    measurements,
    columnsNames,
    selectedColumnNames,
    handleMeasurementsChange,
    handlePossibleValuesChange,
    handleMeasurementAdd,
    handleMeasureEdit,
    handleMeasurementRemove,
    basicColumnsHeadersNum,
    useGradeSpecificColor,
    withReadingAlgorithm,
    skill_areas,
    handleSkillAreaChange,
    newMeasurement,
    isRequiedBasicInfoFilled
  } = props;
  const hasUnassignedColumns =
    measurements.length < columnsNames.length - basicColumnsHeadersNum;
  return (
    <>
      <Table className="selectDataColumnTable">
        <thead>
          <tr>
            {/* <th>#</th> */}
            <th style={{width: withReadingAlgorithm && (props.enterDataManuallyType == "academic") ? "25%" : "40%"}}>
              Column Name 
              <span className="label-asterisk mr-1">*</span>
              <OverlayTrigger
                trigger={"hover"}
                placement="top"
                overlay={
                  <Popover id={"popover-column-name"}>
                    <Popover.Content>Displayed on the column header in the data period.</Popover.Content>
                  </Popover>
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} className="align-middle" />
              </OverlayTrigger>
            </th>
            <th style={{width: withReadingAlgorithm && (props.enterDataManuallyType == "academic") ? "25%" : "25%"}}>
              Display Name
              <span className="label-asterisk mr-1">*</span>
              <OverlayTrigger
                trigger={"hover"}
                placement="top"
                overlay={
                  <Popover id={"tooltip-top-display"}>
                    <Popover.Content>Displayed on the hover of the <strong>Column Name</strong> in the data period.</Popover.Content>
                  </Popover>
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} className="align-middle"/>
              </OverlayTrigger>
            </th>
            {/* <th>Type</th> */}
            {withReadingAlgorithm && (props.enterDataManuallyType == "academic") && <th style={{width: "20%"}}>Reading Areas<span className="label-asterisk mr-1">*</span></th>}
            <th style={{width: withReadingAlgorithm && (props.enterDataManuallyType == "academic") ? "15%" : "20%"}}>Score Range<span className="label-asterisk mr-1">*</span></th>
            <th style={{width: withReadingAlgorithm && (props.enterDataManuallyType == "academic") ? "13%" : "15%"}}>Color Criteria<span className="label-asterisk mr-1">*</span></th>
            <th />
          </tr>
        </thead>
        <tbody>
          {measurements.map((measurement: Measurement, index: number) => {
            if((measurement.color_criteria !== undefined) && (newMeasurement?.color_criteria !== undefined) && (measurement.color_criteria.length < newMeasurement.color_criteria!.length)) {
              newMeasurement?.color_criteria!.filter((element) => {
                
                if(!measurement.color_criteria!.find((data)=> data.grade == element.grade))  {
                  measurement.color_criteria!.push(element)
                }
                
              });
            }
            if (measurement.unique_id === undefined) {
              measurement.unique_id = Date.now();
            } 
            return <ColorCriteriaRow
              key={measurement.id}
              index={index}
              measurement={measurement}
              columnNames={columnsNames}
              selectedColumnNames={selectedColumnNames}
              onMeasureChange={handleMeasurementsChange}
              onPossibleValuesChange={handlePossibleValuesChange}
              onClick={handleMeasureEdit(measurement)}
              onMeasurementRemove={handleMeasurementRemove}
              withReadingAlgorithm={withReadingAlgorithm}
              useGradeSpecificColor={useGradeSpecificColor}
              enterDataManuallyType={props.enterDataManuallyType}
              skill_areas={skill_areas}
              onSkillAreaChange={handleSkillAreaChange}
            />
          })}
        </tbody>
      </Table>
      {hasUnassignedColumns && (
        <div className="leftActions d-flex flex-column align-items-start my-3">
          <button
            onClick={handleMeasurementAdd}
            className="blueBtnSm"
            disabled={!isRequiedBasicInfoFilled}
          >
            <FontAwesomeIcon icon={faPlusCircle} className="mr-1" style={{ color: "white", marginRight: "6px" }} />
            Add Another Column
          </button>
        </div>
      )}
      <hr />
    </>
  );
};

export default MeasurementsTable;
